/* ═══════════════════════════════════════════════════════════
   KALI MIRI — GLOBAL BEHAVIOUR
   Loaded with defer in theme.liquid. One scroll listener.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── SCROLL REVEAL (auto-staggers siblings) ────────────── */
  function initReveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.km-reveal:not(.is-visible)'));
    if (!items.length) return;

    var seen = {};
    items.forEach(function (el) {
      if (el.className.indexOf('km-reveal--d') > -1) return;
      var parent = el.parentElement;
      if (!parent) return;
      if (!parent._kmIdx) { parent._kmIdx = ++seen.n || (seen.n = 1); }
      var sibs = Array.prototype.slice.call(parent.children).filter(function (c) {
        return c.classList && c.classList.contains('km-reveal');
      });
      var i = sibs.indexOf(el);
      if (i > 0) el.style.transitionDelay = Math.min(i * 0.1, 0.4) + 's';
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { obs.observe(el); });
  }

  /* ── FLOATERS: entrance, then parallax ─────────────────── */
  var floaters = [];

  function initFloaters() {
    floaters = Array.prototype.slice.call(document.querySelectorAll('.km-floater-wrap'));
    if (!floaters.length) return;

    floaters.forEach(function (el) {
      el._kmRoot = el.closest('section') || el.parentElement;
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      floaters.forEach(function (el) { el.classList.add('is-visible'); });
      floaters = [];
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = parseFloat(el.dataset.delay || 0) * 1000;
          setTimeout(function () { el.classList.add('is-visible'); }, delay);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    floaters.forEach(function (el) { obs.observe(el); });
  }

  var ticking = false;

  function parallax() {
    var vh = window.innerHeight;
    floaters.forEach(function (el) {
      var speed = parseFloat(el.dataset.speed || 0);
      var root = el._kmRoot;
      if (!speed || !root) return;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var offset = (vh / 2 - (rect.top + rect.height / 2)) * speed;
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    });
    ticking = false;
  }

  /* ── ANNOUNCEMENT BAR COLLAPSE ─────────────────────────── */
  var header, annBar, annHeight = 0, lastY = 0;

  function initHeader() {
    header = document.querySelector('[data-km-header]');
    annBar = document.querySelector('[data-km-ann]');
    if (!header) return;
    annHeight = annBar ? annBar.offsetHeight : 0;
    lastY = window.scrollY;
    updateHeader();
  }

  /* Announcement bar collapses past its own height. The nav itself hides on
     scroll down and returns on scroll up, matching the reference build. The
     4px deadzone stops momentum scrolling from flickering the class. */
  function updateHeader() {
    if (!header) return;
    var y = window.scrollY;

    if (annHeight) header.classList.toggle('is-collapsed', y > annHeight);

    if (document.body.classList.contains('km-lock')) {
      header.classList.remove('nav-hidden');
    } else if (y <= annHeight + 20) {
      header.classList.remove('nav-hidden');
    } else if (y > lastY + 4) {
      header.classList.add('nav-hidden');
    } else if (y < lastY - 4) {
      header.classList.remove('nav-hidden');
    }

    lastY = y;
  }

  /* ── SINGLE SCROLL LISTENER ────────────────────────────── */
  function onScroll() {
    updateHeader();
    if (!ticking && floaters.length && !reduceMotion) {
      window.requestAnimationFrame(parallax);
      ticking = true;
    }
  }

  function boot() {
    initReveal();
    initFloaters();
    initHeader();
    if (floaters.length) parallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (annBar) annHeight = annBar.offsetHeight;
    updateHeader();
  }, { passive: true });

  document.addEventListener('shopify:section:load', boot);
})();

/* ── PRODUCT PAGE: thumbs + qty ─────────────────────────── */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.media-thumb');
  if (thumb && thumb.dataset.full) {
    var main = document.getElementById('kmMainImg');
    if (main) main.src = thumb.dataset.full;
    document.querySelectorAll('.media-thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    return;
  }
  var qtyBtn = e.target.closest('[data-km-qty]');
  if (qtyBtn) {
    var input = document.getElementById('kmQty');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.kmQty, 10);
    input.value = next < 1 ? 1 : next;
  }
});

/* ── ADAPTIVE NAV CONTRAST ──────────────────────────────── */
(function () {
  var header = document.getElementById('siteHeader');
  var navBar = document.getElementById('mainNav');
  if (!header || !navBar) return;

  function updateNavTheme() {
    var zones = document.querySelectorAll('[data-nav]');
    if (!zones.length) return;
    var navRect = navBar.getBoundingClientRect();
    var probeY = navRect.top + navRect.height / 2;
    var theme = 'light';
    for (var i = 0; i < zones.length; i++) {
      var rect = zones[i].getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom > probeY) { theme = zones[i].dataset.nav; break; }
    }
    header.classList.toggle('nav-dark', theme === 'dark');
  }

  updateNavTheme();
  window.addEventListener('scroll', updateNavTheme, { passive: true });
  window.addEventListener('resize', updateNavTheme, { passive: true });
  document.addEventListener('shopify:section:load', updateNavTheme);

  var burger = document.getElementById('kmHamburger');
  var panel = document.getElementById('kmMobileNav');
  if (burger && panel) {
    burger.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('km-lock', open);
    });
  }
})();

/* ── RECIPE FILTER CHIPS ────────────────────────────────── */
document.addEventListener('click', function (e) {
  var chip = e.target.closest('.filter-chip');
  if (!chip) {
    var card = e.target.closest('.rec-card, .recipe-polaroid');
    if (card && card.dataset.href && !e.target.closest('a')) window.location.href = card.dataset.href;
    return;
  }
  var filter = chip.dataset.filter;
  document.querySelectorAll('.filter-chip').forEach(function (c) { c.classList.toggle('active', c === chip); });
  document.querySelectorAll('.rec-card').forEach(function (c) {
    var tags = c.dataset.tags || '';
    c.style.display = (filter === 'all' || tags.indexOf(filter) > -1) ? '' : 'none';
  });
});
/* ── TESTIMONIAL CAROUSEL (4+ cards) ────────────────────── */
function kmInitCarousels() {
  document.querySelectorAll('[data-km-carousel]').forEach(function (root) {
    if (root._kmDone) return;
    root._kmDone = true;
    var viewport = root.querySelector('.km-testi__viewport');
    var track = root.querySelector('.km-testi__track');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dots = root.querySelector('[data-km-dots]');
    var prev = root.querySelector('[data-km-prev]');
    var next = root.querySelector('[data-km-next]');
    if (!viewport || !track || !cards.length) return;

    var GAP = 30;
    var index = 0;

    function perView() { return window.innerWidth <= 849 ? 1 : 3; }
    function maxIndex() { return Math.max(0, cards.length - perView()); }

    function layout() {
      var pv = perView();
      var w = (viewport.clientWidth - GAP * (pv - 1)) / pv;
      track.style.setProperty('--km-card-w', w + 'px');
      return w;
    }

    function render() {
      var w = layout();
      if (index > maxIndex()) index = maxIndex();
      track.style.transform = 'translateX(' + (-index * (w + GAP)) + 'px)';
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
      if (dots) {
        var total = maxIndex() + 1;
        if (dots.children.length !== total) {
          dots.innerHTML = '';
          for (var i = 0; i < total; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            b.dataset.kmPage = i;
            dots.appendChild(b);
          }
        }
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === index); });
      }
    }

    if (prev) prev.addEventListener('click', function () { if (index > 0) { index--; render(); } });
    if (next) next.addEventListener('click', function () { if (index < maxIndex()) { index++; render(); } });
    if (dots) dots.addEventListener('click', function (e) {
      var d = e.target.closest('[data-km-page]');
      if (d) { index = parseInt(d.dataset.kmPage, 10); render(); }
    });
    window.addEventListener('resize', render, { passive: true });
    render();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kmInitCarousels);
else kmInitCarousels();
document.addEventListener('shopify:section:load', kmInitCarousels);
/* TIGER PEEK */
(function () {
  var peeks = [];
  function initPeeks() {
    peeks = Array.prototype.slice.call(document.querySelectorAll('.km-tiger-peek'));
    peeks.forEach(function (t) { t._kmCard = t.closest('.km-cast__cell'); });
    updatePeeks();
  }
  function updatePeeks() {
    if (!peeks.length) return;
    var vh = window.innerHeight;
    peeks.forEach(function (t) {
      var c = t._kmCard;
      if (!c) return;
      var rect = c.getBoundingClientRect();
      var start = vh * 0.95, end = vh * 0.35;
      var lin = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
      var pr = 1 - Math.pow(1 - lin, 3);
      t.style.transform = 'translateY(' + (150 * (1 - pr)) + 'px) rotate(var(--km-peek-r, 9deg))';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPeeks);
  else initPeeks();
  window.addEventListener('scroll', updatePeeks, { passive: true });
  window.addEventListener('resize', updatePeeks, { passive: true });
  document.addEventListener('shopify:section:load', initPeeks);
})();
